import React from 'react';
import Section from '../../../shared/Section/Section';
import { Box, Grid, Typography, useMediaQuery } from '@mui/material';
import PointsList from '../../../shared/PointsList/PointsList';
import VideoBlock from '../../../shared/VideoBlock/VideoBlock';
import { StaticImage } from 'gatsby-plugin-image';

export default function EntranceInterview({
  title,
  video,
  list,
  ymEvent,
  myTargetEvent,
}) {
  const isSm = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  return (
    <Section withoutBg>
      <Grid container spacing={5} sx={{ mb: { xs: 0, lg: -5 } }}>
        <Grid item xs={12} lg={6}>
          <Typography variant="desktopH2" color={'kit.text.main'}>
            {title}
          </Typography>
          <Box sx={{ mt: 5 }}>
            <PointsList
              textProps={{ fontSize: { xs: 14, md: 18 } }}
              list={list}
            />
          </Box>
        </Grid>
        <Grid item xs={12} lg={6}>
          <VideoBlock
            video={video}
            ymEvent={ymEvent}
            myTargetEvent={myTargetEvent}
          >
            <Box sx={{ position: 'relative' }}>
              {isSm ? (
                <StaticImage
                  src="./images/interview.png"
                  layout="constrained"
                  aspectRatio={1.62}
                  placeholder="blurred"
                  alt="interview"
                />
              ) : (
                <StaticImage
                  src="./images/interview.png"
                  layout="constrained"
                  aspectRatio={1.89}
                  placeholder="blurred"
                  alt="interview"
                />
              )}
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: { xs: 0.5, sm: 1 },
                  position: 'absolute',
                  left: {
                    xs: 4,
                    sm: 16,
                  },
                  bottom: {
                    xs: 5,
                    sm: 14,
                  },
                  zIndex: 1,
                }}
              >
                <Typography
                  component={'div'}
                  variant="desktopH5"
                  color={'kit.text.mainInverse'}
                  sx={{
                    fontWeight: 700,
                    fontSize: { xs: 14, md: 18, lg: 24 },
                    backgroundColor: 'rgba(103, 31, 255, 0.3)',
                    backdropFilter: 'blur(5px)',
                    px: { xs: 1, lg: 1.75 },
                    py: { xs: 0.5, lg: 0.88 },
                    borderRadius: 3,
                    lineHeight: 1.4,
                    letterSpacing: '-1.706px',
                    width: 'fit-content',
                  }}
                >
                  ТЕМЫ: ЧТО НАДО ЗНАТЬ?
                </Typography>
                <Typography
                  component={'div'}
                  variant="desktopH5"
                  color={'kit.text.mainInverse'}
                  sx={{
                    fontWeight: 700,
                    fontSize: { xs: 14, md: 18, lg: 24 },
                    backgroundColor: 'rgba(103, 31, 255, 0.3)',
                    backdropFilter: 'blur(5px)',
                    px: { xs: 1, lg: 1.75 },
                    py: { xs: 0.5, lg: 0.88 },
                    borderRadius: 3,
                    lineHeight: 1.4,
                    letterSpacing: '-1.706px',
                    width: 'fit-content',
                  }}
                >
                  КАК ПРОХОДИТ ИНТЕРВЬЮ?
                </Typography>
              </Box>
            </Box>
          </VideoBlock>
          <Typography variant="desktopP1" color={'kit.text.secondary'}>
            2 минуты
          </Typography>
        </Grid>
      </Grid>
    </Section>
  );
}
